<app-sammelbestellerFilter *ngIf="sammelbestellerSpeiseplanService.sammelbestellerFilter"></app-sammelbestellerFilter>
<span *ngIf="!filterErgebnis">Ich habe keinen verfügbaren Content</span>
<span *ngIf="filterErgebnis">ich bin eine ausgabe: {{filterErgebnis | json}}</span>
